var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import GET_CURRENT_TENANT_MANUFACTURERS from 'api/queries/GET_CURRENT_TENANT_MANUFACTURERS';
import client from '../api/environment';
const initialState = {
    items: [],
    selectedManufacturer: {
        item: null,
        status: 'idle',
        error: null,
    },
    status: 'idle',
    error: null,
    pageInfo: {
        hasNextPage: true,
        endCursor: null,
    },
    filters: {
        name: null,
        statusId: '',
    },
};
export const fetchManufacturers = createAsyncThunk('manufacturers/fetchManufacturers', (_, { getState, rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    const state = getState();
    const { filters, pageInfo } = state.manufacturers;
    try {
        const response = yield client.query({
            query: GET_CURRENT_TENANT_MANUFACTURERS,
            variables: {
                name: filters.name || null,
                statusId: filters.statusId || null,
                first: 20,
                after: pageInfo.endCursor,
            },
            fetchPolicy: 'network-only',
        });
        return response.data.me.currentTenant.manufacturers;
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
const manufacturersSlice = createSlice({
    name: 'manufacturers',
    initialState,
    reducers: {
        setFilter(state, action) {
            const { filterName, value } = action.payload;
            state.filters[filterName] = value;
        },
        resetFilters(state) {
            state.filters = {
                name: null,
                statusId: null,
            };
        },
        resetManufacturers(state) {
            state.items = [];
            state.status = 'idle';
            state.pageInfo = { hasNextPage: true, endCursor: null };
        },
        addManufacturer: (state, action) => {
            var _a, _b;
            const data = (_b = (_a = action.payload.data) === null || _a === void 0 ? void 0 : _a.addManufacturer) === null || _b === void 0 ? void 0 : _b.manufacturer;
            state.items = [data, ...state.items];
        },
        archiveManufacturer: (state, action) => {
            const { id } = action.payload;
            const itemIndex = state.items.findIndex((item) => item.id === id);
            if (itemIndex !== -1) {
                state.items[itemIndex] = Object.assign(Object.assign({}, state.items[itemIndex]), { status: 'ARCHIVED' });
            }
        },
        retrieveManufacturer: (state, action) => {
            const { id } = action.payload;
            const itemIndex = state.items.findIndex((item) => item.id === id);
            if (itemIndex !== -1) {
                state.items[itemIndex] = Object.assign(Object.assign({}, state.items[itemIndex]), { status: 'ACTIVE' });
            }
        },
        removeManufacturer: (state, action) => {
            const { id } = action.payload;
            state.items = state.items.filter((item) => item.id !== id);
        },
        updateManufacturer: (state, action) => {
            var _a, _b;
            const data = (_b = (_a = action.payload.data) === null || _a === void 0 ? void 0 : _a.updateManufacturer) === null || _b === void 0 ? void 0 : _b.manufacturer;
            if (!data) {
                return;
            }
            const itemIndex = state.items.findIndex((item) => item.id === data.id);
            if (itemIndex !== -1) {
                state.items[itemIndex] = Object.assign(Object.assign({}, state.items[itemIndex]), data);
            }
            else {
                state.items = [data, ...state.items];
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchManufacturers.pending, (state) => {
            state.status = 'loading';
        })
            .addCase(fetchManufacturers.fulfilled, (state, action) => {
            var _a;
            const newManufacturers = action.payload.edges.map((edge) => edge.node);
            const uniqueManufacturers = newManufacturers.filter((newManufacturer) => !state.items.some((existingManufacturer) => existingManufacturer.id === newManufacturer.id));
            state.items = [...state.items, ...uniqueManufacturers];
            state.pageInfo = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.pageInfo;
            state.status = 'succeeded';
        })
            .addCase(fetchManufacturers.rejected, (state, action) => {
            state.status = 'failed';
            state.error = action.error.message || 'Error fetching manufacturers';
        });
    },
});
export const { setFilter, resetFilters, resetManufacturers, addManufacturer, archiveManufacturer, retrieveManufacturer, removeManufacturer, updateManufacturer, } = manufacturersSlice.actions;
export const selectManufacturers = (state) => state.manufacturers;
export const selectManufacturersStatus = (state) => state.manufacturers.status;
export default manufacturersSlice.reducer;
